import { render, staticRenderFns } from "./HorarioListaAgrupada.vue?vue&type=template&id=63f1473f&scoped=true"
import script from "./HorarioListaAgrupada.vue?vue&type=script&lang=js"
export * from "./HorarioListaAgrupada.vue?vue&type=script&lang=js"
import style0 from "./HorarioListaAgrupada.vue?vue&type=style&index=0&id=63f1473f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f1473f",
  null
  
)

export default component.exports